export default {"src":"/_next/static/media/pet-policy.db1183f7.svg","height":448,"width":656,"blurWidth":0,"blurHeight":0};